
import { Briefcase, TrendingUp, Lock, Building2 } from 'lucide-react';
import { useState } from 'react';
import './CaseStudies.css';

const CaseStudies = () => {
  const [activeStudy, setActiveStudy] = useState(0);

  const cases = [
    {
      icon: <Building2 size={32} />,
      category: "Corporate Espionage",
      title: "Fortune 500 Data Breach Investigation",
      challenge: "Identify source of leaked intellectual property affecting $50M deal",
      solution: "Deployed digital forensics team and conducted internal surveillance over 3 weeks",
      result: "Identified insider threat, recovered stolen data, prevented future breaches",
      timeframe: "21 Days",
      color: "emerald"
    },
    {
      icon: <Lock size={32} />,
      category: "Asset Recovery",
      title: "International Fraud Case",
      challenge: "Track and recover $2.3M in misappropriated funds across 4 countries",
      solution: "Coordinated with international partners, financial forensics, and legal teams",
      result: "85% asset recovery, criminal prosecution of perpetrators",
      timeframe: "90 Days",
      color: "purple"
    },
    {
      icon: <Briefcase size={32} />,
      category: "Background Investigation",
      title: "Executive Due Diligence",
      challenge: "Comprehensive background check on C-level candidate for acquisition",
      solution: "Multi-jurisdictional research, reference verification, financial analysis",
      result: "Uncovered discrepancies preventing costly hiring mistake",
      timeframe: "14 Days",
      color: "amber"
    },
    {
      icon: <TrendingUp size={32} />,
      category: "Insurance Fraud",
      title: "Workers Compensation Fraud",
      challenge: "Verify legitimacy of $500K disability claim",
      solution: "Covert surveillance, social media analysis, medical records review",
      result: "Documented fraudulent claims, case dismissed, $500K saved",
      timeframe: "30 Days",
      color: "cyan"
    }
  ];

  return (
    <section className="case-studies-section">
      <div className="section-container">
        <div className="section-header">
          <div className="section-badge">Success Stories</div>
          <h2 className="section-title">Case Studies</h2>
          <p className="section-subtitle">
            Real investigations, real results. See how we've helped clients solve complex cases.
          </p>
        </div>

        <div className="case-studies-container">
          <div className="case-tabs">
            {cases.map((caseStudy, index) => (
              <button
                key={index}
                className={`case-tab ${activeStudy === index ? 'active' : ''} ${caseStudy.color}`}
                onClick={() => setActiveStudy(index)}
              >
                <div className="tab-icon">{caseStudy.icon}</div>
                <div className="tab-content">
                  <div className="tab-category">{caseStudy.category}</div>
                  <div className="tab-title">{caseStudy.title}</div>
                </div>
              </button>
            ))}
          </div>

          <div className="case-content">
            {cases.map((caseStudy, index) => (
              <div
                key={index}
                className={`case-detail ${activeStudy === index ? 'active' : ''} ${caseStudy.color}`}
              >
                <div className="case-header">
                  <div className="case-icon-large">{caseStudy.icon}</div>
                  <div className="case-meta">
                    <div className="case-category">{caseStudy.category}</div>
                    <h3 className="case-title">{caseStudy.title}</h3>
                    <div className="case-timeframe">
                      <span>Completed in {caseStudy.timeframe}</span>
                    </div>
                  </div>
                </div>

                <div className="case-sections">
                  <div className="case-section">
                    <h4>Challenge</h4>
                    <p>{caseStudy.challenge}</p>
                  </div>
                  <div className="case-section">
                    <h4>Our Approach</h4>
                    <p>{caseStudy.solution}</p>
                  </div>
                  <div className="case-section highlight">
                    <h4>Result</h4>
                    <p>{caseStudy.result}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
